import pdfMake from 'pdfmake/build/pdfmake';
import html2canvas from 'html2canvas';
import GloboAves_logo from '../../../../assets/GloboAves.jpeg';
import everlink_logo from '../../../../assets/everlink-logo.png';
import DMLogistica_logo from '../../../../assets/DM_Logistica.png';

function MakePDF(data, temp_int, humid, co2, vibra, odometer, initialDate, finalDate, companyName) {


  const chartElement1 = document.getElementById('canvaIDtemperature');
  const chartElement2 = document.getElementById('canvaIDhumidity');
  const chartElement3 = document.getElementById('canvaIDco2');
  const chartElement4 = document.getElementById('canvaIDmechnical-vibrations');
  const chartElement5 = document.getElementById('canvaIDThermoKing');
  const chartElement6 = document.getElementById('canvaIDPowerTension');

  generatePDF(data, temp_int, humid, co2, vibra, odometer, chartElement1, chartElement2, chartElement3, chartElement4, chartElement5, chartElement6, initialDate, finalDate, companyName)
}

function convertImageToBase64(imagePath) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imagePath;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };
  });
}

async function createHeader(data, initialDate, finalDate, distanceRoute, companyName) {

  const imagePath = companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? DMLogistica_logo : companyName === "ManagementCompany" ? everlink_logo : GloboAves_logo;
  let imageLogo;
  await convertImageToBase64(imagePath)
    .then((base64String) => {
      imageLogo = base64String;
    })
    .catch((error) => {
      console.error(error);
    });
  try {
    const header = {
      margin: [15, 10, 15, 0],
      columns: [
        {
          stack: [
            {
              table: {
                headerRows: 1,
                widths: [100, '*', 100],
                heights: [35, 35, 35],
                body: [
                  [
                    { image: imageLogo, width: companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? 65 : companyName === "ManagementCompany" ? 80 : 75, height: companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? 20 : companyName === "ManagementCompany" ? 20 : 25, margin: [12, companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? 6 : companyName === "ManagementCompany" ? 8 : 3, 0, 0] },
                    {
                      stack: [
                        { text: 'Gestão de Ambientes\n', bold: true, alignment: 'center' },
                        { text: `Veículo: ${data.vehiclePlate}`, fontSize: 8, absolutePosition: { x: 135, y: 34 } },
                        { text: `Período: ${initialDate} até ${finalDate} \n`, fontSize: 8, absolutePosition: { x: 210, y: 29 } },
                        { text: `Distância percorrida no período: ${isNaN(distanceRoute) ? 0 : distanceRoute.toFixed(2).toString().replace('.', ',')} km \n`, fontSize: 8, absolutePosition: { x: 210, y: 38 } }
                      ],
                    },
                    { image: everlink_logo, width: 80, height: 20, margin: [8, 5, 0, 0] },
                  ],
                ],
              },
            },
          ],
        },
      ],
    };
    return header;
  } catch (error) {
    throw error;
  }
}


async function generatePDF(data, temp_int, humid, co2, vibra, odometer, chartElement1, chartElement2, chartElement3, chartElement4, chartElement5, chartElement6, initialDate, finalDate, companyName) {

  const listInt1 = temp_int.sensor1Values;
  const listInt2 = temp_int.sensor2Values;
  const listInt3 = temp_int.sensor3Values;
  const listHumd1 = humid.sensor1Values;
  const listHumd2 = humid.sensor2Values;
  const listCO1 = co2.sensor1Values;
  const listVibra1 = vibra.sensor1Values;
  const listOdometer = odometer.sensor1Values;

  const distanceRoute = (parseInt(listOdometer[listOdometer.length - 1]) - parseInt(listOdometer[0])) / 1000;

  return new Promise((resolve) => {

    const canvas = document.createElement('canvas');
    const chartRect = chartElement2.getBoundingClientRect();

    canvas.width = chartRect.width;
    canvas.height = chartRect.height;

    const c1 = html2canvas(chartElement1);
    const c2 = html2canvas(chartElement2);
    const c3 = html2canvas(chartElement3);
    const c4 = html2canvas(chartElement4);
    const c5 = html2canvas(chartElement5);
    const c6 = html2canvas(chartElement6);



    var minReduce = function (a, b) { return (isNaN(b) || b > a) ? a : b }
    var maxRduce = function (a, b) { return (isNaN(b) || b < a) ? a : b }
    const maxInt1 = listInt1.reduce(maxRduce, Number.MIN_VALUE);
    const minInt1 = listInt1.reduce(minReduce, Number.MAX_VALUE);

    const maxInt2 = listInt2.reduce(maxRduce, Number.MIN_VALUE);
    const minInt2 = listInt2.reduce(minReduce, Number.MAX_VALUE);

    const maxInt3 = listInt3.reduce(maxRduce, Number.MIN_VALUE);
    const minInt3 = listInt3.reduce(minReduce, Number.MAX_VALUE);

    const maxInt4 = listHumd1.reduce(maxRduce, Number.MIN_VALUE);
    const minInt4 = listHumd1.reduce(minReduce, Number.MAX_VALUE);

    const maxInt5 = listHumd2.reduce(maxRduce, Number.MIN_VALUE);
    const minInt5 = listHumd2.reduce(minReduce, Number.MAX_VALUE);

    const maxInt6 = listCO1.reduce(maxRduce, Number.MIN_VALUE);
    const minInt6 = listCO1.reduce(minReduce, Number.MAX_VALUE);

    const maxInt8 = listVibra1.reduce(maxRduce, Number.MIN_VALUE);
    const minInt8 = listVibra1.reduce(minReduce, Number.MAX_VALUE);

    var filteredList = listInt1.filter(value => !isNaN(value));
    const sumTP = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageTempP = sumTP / filteredList.length;

    filteredList = listInt2.filter(value => !isNaN(value));
    const sumTS = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageTempS = sumTS / filteredList.length;

    filteredList = listInt3.filter(value => !isNaN(value));
    const sumTE = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageTempE = sumTE / filteredList.length;

    filteredList = listHumd1.filter(value => !isNaN(value));
    const sumUP = filteredList.reduce((acc, cur) => acc + cur, 0)
    const averageUp = sumUP / filteredList.length;

    filteredList = listHumd2.filter(value => !isNaN(value));
    const sumUS = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageUs = sumUS / filteredList.length;


    filteredList = listCO1.filter(value => !isNaN(value));
    const sumCOP = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageCOP = sumCOP / filteredList.length;

    filteredList = listVibra1.filter(value => !isNaN(value));
    const sumVP = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageVP = sumVP / filteredList.length;


    Promise.all([c1, c2, c3, c4, c5, c6]).then(async ([c1, c2, c3, c4, c5, c6]) => {
      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [15, 50, 15, 40],
        header: await createHeader(data, initialDate, finalDate, distanceRoute, companyName),
        content: [
          { image: c1.toDataURL('image/png'), width: 575, height: 200, absolutePosition: { x: 10, y: 70 }, },
          { text: '(ºC)', fontSize: 8, color: 'black', absolutePosition: { x: 25, y: 65 }, bold: true },
          { image: c5.toDataURL('image/png'), width: 575, height: 200, absolutePosition: { x: 10, y: 300 }, },
          { image: c2.toDataURL('image/png'), width: 575, height: 200, absolutePosition: { x: 10, y: 550 }, },
          { text: '(%)', fontSize: 8, color: 'black', absolutePosition: { x: 25, y: 545 }, bold: true },

          { text: '', pageBreak: 'before' },
          { image: c3.toDataURL('image/png'), width: 575, height: 200, absolutePosition: { x: 10, y: 70 } },
          { text: '(PPM)', fontSize: 8, color: 'black', absolutePosition: { x: 25, y: 65 }, bold: true },
          { image: c5.toDataURL('image/png'), width: 575, height: 200, absolutePosition: { x: 10, y: 300 }, },
          { image: c4.toDataURL('image/png'), width: 575, height: 200, absolutePosition: { x: 10, y: 550 }, },
          { text: '(g)', fontSize: 8, color: 'black', absolutePosition: { x: 25, y: 545 }, bold: true },

          { text: '', pageBreak: 'before' },
          { image: c6.toDataURL('image/png'), width: 575, height: 200, absolutePosition: { x: 10, y: 70 }, },
          { text: '(V)', fontSize: 8, color: 'black', absolutePosition: { x: 25, y: 65 }, bold: true },
          {
            margin: [0, 250, 0, 0],
            table: {
              widths: [555],
              heights: [25],
              body: [

                [
                  {
                    table: {
                      widths: ['*', 100],
                      heights: [25, 25, 25, 25, 25, 25],
                      body: [
                        [{ text: 'Ocorrências', fontSize: 18 }, { text: "Quantidade", fontSize: 18, alignment: 'center' }],
                        [{ text: 'Total Alarmes', fontSize: 18 }, { text: data.mostQtdy.toString(), fontSize: 14, alignment: "center" }],
                        [{ text: 'Paradas sem descarga, cadastrada', fontSize: 18 }, { text: data.numberOfEvents_Withoutcharge.toString(), fontSize: 14, alignment: "center" }],
                        [{ text: 'Paradas com descarga, cadastrada', fontSize: 18 }, { text: data.numberOfEvents_Charge.toString(), fontSize: 14, alignment: "center" }],
                        [{ text: 'Paradas sem descarga, não cadastrada', fontSize: 18 }, { text: data.numberOfEvents_NotWithoutcharge.toString(), fontSize: 14, alignment: "center" }],
                        [{ text: 'Paradas com descarga, não cadastrada', fontSize: 18 }, { text: data.numberOfEvents_NotCharge.toString(), fontSize: 14, alignment: "center" }],
                      ],
                    },
                    border: [true, true, true, false],
                  },
                ],
                [
                  {
                    table: {
                      widths: ['*', '*', '*', '*'],
                      heights: [25, 25, 25, 25, 25, 25, 25, 25, 25, 25],
                      body: [
                        ['', { text: 'Mínimo', fontSize: 18 }, { text: 'Média', fontSize: 18 }, { text: 'Máximo', fontSize: 18 }],
                        [
                          {
                            stack: [
                              { text: 'Temp P  ', fontSize: 14 },
                              { text: '1', fontSize: 8, color: 'grey', relativePosition: { x: 60, y: -15 } },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt1.toString(), fontSize: 14
                          }, { text: parseFloat(averageTempP).toFixed(2).toString(), fontSize: 14 }, {
                            text: maxInt1.toString(), fontSize: 14
                          },
                        ],
                        [
                          {
                            stack: [
                              { text: 'Temp S  ', fontSize: 14 },
                              { text: '1', fontSize: 8, color: 'grey', relativePosition: { x: 60, y: -15 } },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt2.toString(), fontSize: 14
                          }, { text: parseFloat(averageTempS).toFixed(2).toString(), fontSize: 14 }, {
                            text: maxInt2.toString(), fontSize: 14
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Temp E  ', fontSize: 14 },
                              { text: '1', fontSize: 8, color: 'grey', relativePosition: { x: 60, y: -15 } },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt3.toString(), fontSize: 14
                          }, { text: parseFloat(averageTempE).toFixed(2).toString(), fontSize: 14 }, {
                            text: maxInt3.toString(), fontSize: 14
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Umid P  ', fontSize: 14 },
                              { text: '2', fontSize: 8, color: 'grey', relativePosition: { x: 60, y: -15 } },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt4.toString(), fontSize: 14
                          }, { text: parseFloat(averageUp).toFixed(2).toString(), fontSize: 14 }, {
                            text: maxInt4.toString(), fontSize: 14
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Umid S  ', fontSize: 14 },
                              { text: '2', fontSize: 8, color: 'grey', relativePosition: { x: 60, y: -15 } },
                            ],
                            fontSize: 14
                          },
                          { text: minInt5.toString(), fontSize: 14 }, { text: parseFloat(averageUs).toFixed(2).toString(), fontSize: 14 }, {
                            text: maxInt5.toString(), fontSize: 14
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'CO2  ', fontSize: 14 },
                              { text: '3', fontSize: 8, color: 'grey', relativePosition: { x: 60, y: -15 } },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt6.toString(), fontSize: 14
                          }, { text: parseFloat(averageCOP).toFixed(2).toString(), fontSize: 14 }, {
                            text: maxInt6.toString(), fontSize: 14
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Vibração  ', fontSize: 14 },
                              { text: '4', fontSize: 8, color: 'grey', relativePosition: { x: 60, y: -15 } },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt8.toString(), fontSize: 14
                          }, { text: parseFloat(averageVP).toFixed(2).toString(), fontSize: 14 }, {
                            text: maxInt8.toString(), fontSize: 14
                          }
                        ],
                      ],




                    },
                    border: [true, false, true, false],
                  },
                ],
                [
                  {
                    table: {
                      widths: ['*', '*', '*', '*'],
                      margin: [10, 10, 10, 10],
                      body: [
                        [
                          {
                            border: [false, false, false, false],
                            text: [
                              { text: '1 ', fontSize: 9 },
                              { text: 'Expresso em ºC', fontSize: 8 }

                            ],

                            color: 'grey',
                          },
                          {
                            border: [false, false, false, false],
                            text: [
                              { text: '2 ', fontSize: 9 },
                              { text: 'Expresso em %', fontSize: 8 }
                            ],
                            color: 'grey',
                          },
                          {
                            border: [false, false, false, false],
                            text: [
                              { text: '3 ', fontSize: 9 },
                              { text: 'Expresso em PPM', fontSize: 8 }

                            ],
                            color: 'grey',
                          },
                          {

                            border: [false, false, false, false],
                            text: [
                              { text: '4 ', fontSize: 9 },
                              { text: 'Expresso em g', fontSize: 8 }
                            ],
                            fontSize: 8,
                            color: 'grey',
                          },
                        ],
                      ],

                    },
                    border: [true, false, true, false],
                  },
                ],
                [
                  {
                    table: {
                      body: [
                        [

                        ],
                      ],

                    },
                    border: [true, false, true, false],
                  },
                ],
                [
                  {
                    table: {
                      body: [
                        [

                        ],
                      ],

                    },
                    border: [true, false, true, true],
                  },
                ],

              ],
            },
          },
        ],
        footer: function (currentPage, pageCount) {
          return {
            text: `Página ${currentPage.toString()}/${pageCount.toString()}`,
            alignment: 'right',

            fontSize: 10,
            color: 'black',
            margin: [50, 0],
          };

        }

      };
      pdfMake.createPdf(docDefinition).download(data.vehiclePlate + '-' + initialDate, () => {
        resolve();
      });
    });
  });
}



export default MakePDF;